export const GmbMediaStorageType = {
  LOCAL_POST: 1,
  PHOTO: 2
};
